var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 23.5,
    r: 23.5,
    fill: "#646464",
    fillOpacity: 0.34
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8349 33.3025C37.2234 29.0007 38.1043 21.1452 33.8025 15.7567C29.5008 10.3682 21.6452 9.48727 16.2567 13.7891C10.8682 18.0908 9.98728 25.9464 14.2891 31.3349C18.5909 36.7234 26.4464 37.6043 31.8349 33.3025Z",
    fill: "url(#paint0_radial_355_774)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_355_774",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.3848 19.8763) rotate(-167.431) scale(17.2772)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12B7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1877B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#1C4F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#782F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#BD1784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D90E81"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotcircle);
export default __webpack_public_path__ + "static/media/dotcircle.8c091d5ace90ad1671a3b416542bb700.svg";
export { ForwardRef as ReactComponent };